import * as React from 'react';
import useService from '@lifeomic/phc-web-toolkit/src/hooks/useService';
import {
  AutoSuggest,
  AutoSuggestListItem,
} from '@lifeomic/phc-web-toolkit/src/components/AutoSuggest';
import { AxiosResponse } from 'axios';
import { BaseFilterComponent } from '../../../FilterResultsManager/components/types';
import { BaseFilterOption } from '../../../FilterResultsManager/options/types';
import { Filter } from '../../../types';

export interface JaxTypeaheadFilterOption extends BaseFilterOption {
  injectedProps: {
    gene: string;
    id: string;
    searchKey: string;
    service: any;
  };
}

interface JaxTypeaheadProps
  extends JaxTypeaheadFilterOption,
    BaseFilterComponent {}

export const JaxTypeahead: React.FC<JaxTypeaheadProps> = ({
  injectedProps: { gene, id, searchKey, service },
  onFilterAdd,
  origin,
}) => {
  const [suggestions, setSuggestions] = React.useState([]);
  const [fetchSuggestions, fetchSuggestionsState] = useService(service);

  const getSuggestions = async (value: string) => {
    const response: AxiosResponse<any> = await fetchSuggestions({
      gene,
      filters: { [`~${searchKey}`]: value },
      pageSize: 30,
      suggest: searchKey,
    });

    if (response?.data?.items) {
      setSuggestions(response.data.items);
    }
  };

  const renderSuggestion = (
    suggestion: string | Record<string, unknown>,
    isHighlighted: boolean,
  ) => {
    if (!suggestion) {
      return null;
    }

    const title =
      typeof suggestion === 'string'
        ? suggestion
        : (suggestion[searchKey] as string);
    return <AutoSuggestListItem title={title} isHighlighted={isHighlighted} />;
  };

  const onSuggestionSelected = ({
    suggestion,
  }: {
    suggestion: string | Record<string, unknown>;
  }) => {
    const searchValue =
      typeof suggestion === 'string'
        ? suggestion
        : (suggestion[searchKey] as string | boolean);
    const filter: Filter = {
      id: `${id}+${suggestion}`,
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      origin,
      searchKey,
      searchValue,
    };
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    onFilterAdd(filter);
  };

  return (
    <AutoSuggest
      fetchSuggestions={getSuggestions}
      getSuggestionValue={suggestion => suggestion}
      isLoading={fetchSuggestionsState.isFetching}
      onSuggestionSelected={onSuggestionSelected}
      renderSuggestion={renderSuggestion}
      suggestions={suggestions}
    />
  );
};
